import { ReactNode, useCallback, useMemo, useState } from "react";

export type MessageModalType = "CONFIRMATION" | "ERROR" | "INFO" | "WARNING";

export interface MsgModalModel {
  type: MessageModalType;
  title: ReactNode;
  message: ReactNode;
  detail?: ReactNode;
  okText?: ReactNode;
  cancelText?: ReactNode;
  width?: number | string;
}

export interface MessageModalHelper {
  model: MsgModalModel | undefined;
  setModel: (msgModalModel: MsgModalModel | undefined) => boolean;
  onClose: () => void;
}

export const useMessageModalHelper = (): MessageModalHelper => {
  const [msgModalModel, setMsgModalModel] = useState<MsgModalModel>();

  const onClose = useCallback(() => {
    setMsgModalModel(undefined);
  }, [setMsgModalModel]);

  const setModel = useCallback((model: MsgModalModel | undefined) => {
    if (msgModalModel === undefined) {
      setMsgModalModel(model);
      return true;
    }
    return false;
  }, [msgModalModel]);

  return useMemo(() => ({
    model: msgModalModel,
    setModel,
    onClose,
  }), [msgModalModel, onClose, setModel]);
};
